@if (user && form) {
  <div class="profile_information--content--large" [formGroup]="form">
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <div class="profile_information--asterisk">*</div>
        <span i18n="@@ProfileInformation-Title">Title</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <select class="profile_information--input" formControlName="title">
          @for (personTitle of personTitles; track personTitle) {
            <option [ngValue]="personTitle.title">
              {{ personTitle.title }}
            </option>
          }
        </select>
        <fa-icon [icon]="faChevronDown"></fa-icon>
        @if (form.get('title').invalid || form.get('title').touched) {
          <div>
            @if (form.get('title').errors?.required) {
              <div
                class="profile_information--error-message"
                i18n="@@ProfileInformation-Title-required"
              >
                Title required
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <div class="profile_information--asterisk">*</div>
        <span i18n="@@ProfileInformation-Fornames">Forename(s)</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <input class="profile_information--input" formControlName="forename" />
        @if (form.get('forename').invalid || form.get('forename').touched) {
          <div>
            @if (form.get('forename').errors?.required) {
              <div
                class="profile_information--error-message"
                i18n="@@ProfileInformation-Forname-required"
              >
                Forname required
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <div class="profile_information--asterisk">*</div>
        <span i18n="@@ProfileInformation-Surname">Surname</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <input class="profile_information--input" formControlName="surname" />
        @if (form.get('surname').invalid || form.get('surname').touched) {
          <div>
            @if (form.get('surname').errors?.required) {
              <div
                class="profile_information--error-message"
                i18n="@@ProfileInformation-Surname-required"
              >
                Surname required
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <span i18n="@@ProfileInformation-DOB">DOB</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <ngbd-datepicker-i18n>
          <input
            class="profile_information--input"
            placeholder="DD/MM/YYYY"
            i18n-placeholder
            #d="ngbDatepicker"
            ngbDatepicker
            firstDayOfWeek="7"
            [navigation]="'arrows'"
            (click)="d.toggle()"
            formControlName="dob"
          />
          <fa-icon [icon]="faCalendar"></fa-icon>
        </ngbd-datepicker-i18n>
      </div>
      @if (form.get('dob').invalid || form.get('dob').touched) {
        <div>
          @if (form.get('dob').errors) {
            <div class="profile_information--error-message" i18n="@@ProfileInformation-DOB-invalid">
              DOB invalid
            </div>
          }
        </div>
      }
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <div class="profile_information--asterisk">*</div>
        <span i18n="@@ProfileInformation-Email">Email</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <input class="profile_information--input" formControlName="email" />
        @if (form.get('email').invalid || form.get('email').touched) {
          <div>
            @if (form.get('email').errors?.required) {
              <div
                class="profile_information--error-message"
                i18n="@@ProfileInformation-Email-required"
              >
                Email required
              </div>
            }
            @if (form.get('email').errors?.email) {
              <div
                class="profile_information--error-message"
                i18n="@@ProfileInformation-Email-invalid"
              >
                Email invalid
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <div class="profile_information--asterisk">*</div>
        <span i18n="@@ProfileInformation-Language">Language</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <select class="profile_information--input" formControlName="selectedLanguage">
          @for (language of user.availableLanguages; track language) {
            <option [ngValue]="language.id">{{ language.name }} - {{ language.isoCode }}</option>
          }
        </select>
        <fa-icon [icon]="faChevronDown"></fa-icon>
        @if (form.get('selectedLanguage').invalid || form.get('selectedLanguage').touched) {
          <div>
            @if (form.get('selectedLanguage').errors?.required) {
              <div
                class="profile_information--error-message"
                i18n="@@ProfileInformation-Language-required"
              >
                Language required
              </div>
            }
          </div>
        }
      </div>
    </div>
    <div formArrayName="phoneNumbers">
      @for (phoneForm of phoneNumbers.controls; track phoneForm; let i = $index) {
        <div [formGroupName]="i" class="profile_information--input-container">
          <div class="profile_information--input-label">
            <div class="profile_information--asterisk">*</div>
            <span>{{ phoneForm.get('description').value }}</span>
            @if (phoneForm.get('userPrimary').value === true) {
              <span i18n="@@ProfileInformation-Primary">(Primary)</span>
            }
          </div>
          <div [formGroup]="phoneForm" class="profile_information--input-wrapper">
            <div class="profile_information--phone-wrapper">
              <div class="profile_information--country-code">
                <span>{{ phoneForm.get('type').value }}</span>
                <select class="profile_information--wrapped-input" formControlName="type">
                  @for (phoneType of phoneTypes; track trackbyId($index, phoneType)) {
                    <option [ngValue]="phoneType">
                      <span> {{ phoneType | translate }}</span>
                      ({{ phoneType }})
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
              <div class="profile_information--country-code">
                <span>({{ phoneForm.get('countryCode').value }})</span>
                <select class="profile_information--wrapped-input" formControlName="countryCode">
                  @for (country of countries; track trackbyId($index, country)) {
                    <option [ngValue]="country.dCode">
                      <span> {{ country.cName | translate }}</span>
                      ({{ country.dCode }})
                    </option>
                  }
                </select>
                <fa-icon [icon]="faChevronDown"></fa-icon>
              </div>
              <input class="profile_information--mobile-number" formControlName="number" />
            </div>
            @if (phoneForm.get('number').invalid || phoneForm.get('number').touched) {
              <div>
                @if (phoneForm.get('number').errors?.required) {
                  <div
                    class="profile_information--error-message"
                    i18n="@@ProfileInformation-Number-required"
                  >
                    Number required
                  </div>
                }
                @if (phoneForm.get('number').errors?.minlength) {
                  <div class="profile_information--error-message">
                    <span i18n="@@ProfileInformation-The-minimum-phone-number-length-is-10-digits"
                      >The minimum phone number length is 10 digits. Actual length
                    </span>
                    {{ phoneForm.get('number').errors?.minlength.actualLength }}
                  </div>
                }
                @if (phoneForm.get('number').errors?.maxlength) {
                  <div class="profile_information--error-message">
                    <span i18n="@@ProfileInformation-The-maximum-phone-number-length-is-15-digits"
                      >The maximum phone number length is 15 digits. Actual length
                    </span>
                    {{ phoneForm.get('number').errors?.maxlength.actualLength }}
                  </div>
                }
                @if (phoneForm.get('number').errors?.pattern) {
                  <div
                    class="profile_information--error-message"
                    i18n="@@ProfileInformation-OnlyNumbersAreAllowed"
                  >
                    Only Numbers are allowed
                  </div>
                }
              </div>
            }
          </div>
        </div>
      }
    </div>
    <div formArrayName="additionalEmail">
      @for (emailForm of additionalEmail.controls; track emailForm; let i = $index) {
        <div [formGroupName]="i">
          <div [formGroup]="emailForm" class="profile_information--input-wrapper">
            <div class="profile_information--input-container">
              <div class="profile_information--input-label">
                <span i18n="@@ProfileInformation-AdditionalEmail">Additional Email</span>:
              </div>
              <div class="profile_information--input-wrapper">
                <input class="profile_information--input" formControlName="value" />
                @if (emailForm.get('value').invalid || emailForm.get('value').touched) {
                  <div>
                    @if (emailForm.get('value').errors?.email) {
                      <div
                        class="profile_information--error-message"
                        i18n="@@ProfileInformation-Emailinvalid"
                      >
                        Email invalid
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <span i18n="@@ProfileInformation-EmergencyContactName">Emergency Contact Name</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <input class="profile_information--input" formControlName="emergencyContactName" />
      </div>
    </div>
    <div class="profile_information--input-container">
      <div class="profile_information--input-label">
        <span i18n="@@ProfileInformation-EmergencyContactNumber">Emergency Contact Number</span>:
      </div>
      <div class="profile_information--input-wrapper">
        <input class="profile_information--input" formControlName="emergencyContactPhone" />
      </div>
    </div>
  </div>
}
